import React, { useRef, useState } from 'react'
import Cropper from 'react-easy-crop';
import axios from '../../API/axios';
import SuccessToast from '../SuccessToast';
import WarningToast from '../WarningToast';
import ErrorToast from '../ErrorToast';
import getCroppedImg from "./cropImage";
import { dataURLtoFile } from './dataUrlToFile'
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { people } from '../../config/imagesLink';

const ProfileBackground = ({ userData, getUserProfile, setOpenBgModal, openBgModal }) => {
    const sessionId = localStorage.getItem("sessionId");
    //   State for Toasters
    const [toastMessage, setToastMessage] = useState("");
    const [showToast, setShowToast] = useState(false);
    const [warningToastMessage, setWarningToastMessage] = useState("");
    const [showWarningToast, setShowWarningToast] = useState(false);
    const [ErrorToastMessage, setErrorToastMessage] = useState("");
    const [showErrorToast, setShowErrorToast] = useState(false);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    const [rotation, setRotation] = useState(0);
    const [inputOpen, setInputOpen] = useState(false);
    const [croppedArea, setCroppedArea] = useState(null)
  const language = localStorage.getItem("Lang");

    const onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
        setCroppedArea(croppedAreaPixels)
    }

    const [image, setImage] = useState(null);
    const [bgModal, setBgModal] = useState(false);
    const handleBgCloseModal = () => {
        setBgModal(false);
    };
    const fileInputRef = useRef(null);
    const cropperRef = useRef(null);


    const onSelectFile = (event) => {
        if (event.target.files && event.target.files.length > 0) {
            const reader = new FileReader();
            reader.onload = () => {
                console.warn("=======setImage===>", reader.result);
                setImage(reader.result);
                setBgModal(true);
            };
            reader.readAsDataURL(event.target.files[0]);
        }
    };


    const base64ToBlob = (base64, mimeType) => {
        const byteCharacters = atob(base64.split(",")[1]);
        const byteNumbers = new Array(byteCharacters.length);
        for (let i = 0; i < byteCharacters.length; i++) {
            byteNumbers[i] = byteCharacters.charCodeAt(i);
        }
        const byteArray = new Uint8Array(byteNumbers);
        return new Blob([byteArray], { type: mimeType });
    };


    const handleFileInputClick = (event) => {
        // event.preventDefault();
        // event.stopPropagation();
        if (fileInputRef.current) {
            fileInputRef.current.click();
        }
    };


    //************************ Background Upload  ************************//


    const onSelectCropImage = async () => {
        try {
            const canvas = await getCroppedImg(image, croppedArea, rotation)
            console.log('canvas', canvas);
            const canvasDataUrl = canvas.toDataURL("image/jpeg")
            const urlToFile = dataURLtoFile(canvasDataUrl, "cropped-image.jpg")
            BgImageUpload(urlToFile)
        } catch (error) {
            console.log(error)
        }
    }

    const BgImageUpload = async (imageFile) => {
        console.log('canvas', imageFile);
        try {
            //   if (croppedImage !== null) {
            // const mimeType = image.split(",")[0].split(":")[1].split(";")[0];
            // const blob = base64ToBlob(image, mimeType);
            // console.log("blob", blob.type);
            const formData = new FormData();
            formData.append("DeviceType", "Web");
            formData.append("sessionId", sessionId);
            formData.append("BackGroundImage", imageFile);
            formData.append("Language",language === "en" ? "" : language,);
            const res = await axios.post(
                "/UserAccount/SetBackgroundImage",
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                }
            );
            getUserProfile();
            setToastMessage(res.data.message);
            setShowToast(true);
            // setBgModal(false);
            // setCroppedImage(null);
            setImage(null);
            setInputOpen(false);

        } catch (error) {
            if (error.response && error.response.status === 404) {
                setWarningToastMessage(error.response.data.message);
                setShowWarningToast(true);
            } else {
                setErrorToastMessage(error.response.data.message);
                setShowErrorToast(true);
            }
        }

        handleBgCloseModal();
    };

    return (
        <>
            <div className="Profilebackground">
                <div
                    className="background-overlay"
                    onClick={(event) => setOpenBgModal(true)}
                >
                    <img
                        src={userData?.profileInfo?.backGroundImage || people.background}
                        alt="Selected"
                        height={400}
                        onError={(e) => {
                          e.target.onerror = null;
                          e.target.src = people.background;
                        }}
                    />
                    {/* {userData?.profileInfo?.isOwn && (
                        <>
                            <label htmlFor="fileInput" className="backgroundimg-edit">
                                <div>
                                    <input
                                        type="file"
                                        accept="image/*"
                                        onChange={onSelectFile}
                                        ref={fileInputRef}
                                        style={{ display: "none" }}
                                        onClick={(event) => {
                                            event.target.value = null;
                                        }}
                                    />
                                    <label
                                        onClick={(event) => {
                                            handleFileInputClick(event);
                                        }}
                                        style={{
                                            cursor: "pointer",
                                            display: "inline-flex",
                                            alignItems: "center",
                                            padding: "8px",
                                            borderRadius: "4px",
                                            backgroundColor: "transparent",
                                        }}
                                    >
                                    </label>
                                </div>
                            </label>
                        </>
                    )} */}
                </div>
            </div>



            {bgModal && (
                <div
                    className="modal fade modal-lg show postAdd"
                    tabIndex="-1"
                    role="dialog"
                    style={{ display: "block" }}
                >
                    <div className="modal-dialog modal-dialog-centered" role="document">
                        <div className="modal-content d-flex justify-content-around p-2">
                            <div className="modalBorder d-flex justify-content-between align-items-center p-2">
                                <h6>Background pic</h6>
                                <CloseSharpIcon
                                    className="material-symbols-sharp me-2 pointer"
                                    onClick={handleBgCloseModal}
                                />
                            </div>
                            <div className="cropperContianer">
                                {image && (
                                    <div className="crop-app">
                                        <div className="crop-container">
                                            <Cropper
                                                ref={cropperRef}
                                                image={image}
                                                crop={crop}
                                                zoom={zoom}
                                                rotation={rotation}
                                                // cropShape="round"
                                                aspect={16 / 4}
                                                onCropChange={setCrop}
                                                onCropComplete={onCropComplete}
                                                onRotationChange={setRotation}
                                                onZoomChange={setZoom}
                                            />
                                        </div>
                                    </div>
                                )}
                            </div>
                            <div className="text-end mt-2">
                                <button className="mainBtn1" onClick={() =>
                                    // BgImageUpload
                                    onSelectCropImage()

                                }>
                                    Done
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            <SuccessToast
                show={showToast}
                message={toastMessage}
                onClose={() => setShowToast(false)}
            />

            <WarningToast
                show={showWarningToast}
                message={warningToastMessage}
                onClose={() => setShowWarningToast(false)}
            />

            <ErrorToast
                show={showErrorToast}
                message={ErrorToastMessage}
                onClose={() => setShowErrorToast(false)}
            />
        </>
    )
}

export default ProfileBackground